module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/forgot-password-component/forgot-password-component.component.css
// module id = ./src/app/forgot-password-component/forgot-password-component.component.css
// module chunks = main